import styled from 'styled-components';
import { Box, spacing } from '@landr/maestro';

const Wrapper = styled(Box)<{
    isLinked?: boolean;
}>`
    width: ${spacing('xxl')};
    height: ${spacing('xxl')};
    cursor: ${({ isLinked }) => (isLinked ? 'pointer' : 'default')};

    ${({ theme }): string => theme.breakpoint('md')` 
        width: ${spacing('xl')};
        height: ${spacing('xl')};
    `}
`;

const Styled = { Wrapper };

export default Styled;
